import AdminModal from './AdminModal.vue';
import MuteModal from './MuteModal.vue';
import ReportModal from './ReportModal.vue';
import WarningModal from './WarningModal.vue';
import './modals.less';


export default {
  AdminModal,
  MuteModal,
  ReportModal,
  WarningModal,
};